/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, OnInit, output, signal, viewChild } from '@angular/core';
import { CdkPortalOutlet, ComponentPortal } from '@angular/cdk/portal';

@Component({
  selector: 'lib-side-panel-container',
  imports: [CdkPortalOutlet],
  templateUrl: './side-panel-host.component.html',
  styleUrl: './side-panel-host.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidePanelHostComponent implements OnInit {
  closed = output<any>();

  portalOutlet = viewChild<CdkPortalOutlet>(CdkPortalOutlet);

  isOpen = signal(false);

  ngOnInit() {
    setTimeout(() => {
      this.isOpen.set(true);
    }, 10);
  }

  attachPortal(portalToAttach: ComponentPortal<unknown>) {
    this.portalOutlet()?.attach(portalToAttach);
  }

  close(result?: any) {
    this.isOpen.set(false);
    setTimeout(() => this.closed.emit(result), 300); // wait for animation
  }
}
